import { Grid2, Typography, Box, Button, Modal, Slide, } from "@mui/material"
import { memo, useMemo, useEffect, useState } from "react";
import Table from "../../components/Table"
import AddIcon from '@mui/icons-material/Add';
import {
    getOwners,
    getInspectors,
    getOrganizations,
    getUsersData,
} from "../../api/index.js";
import Spinner from "../../components/Spinner.js";
import OwnerForm from "../../components/forms/OwnerForm.js";
import useListStyles from "../../components/styles/List.js";
import {
    codeHeader,
    inspectorHeader,
    ownerLastNameHeader,
    firstNameHeader,
    fatherNameHeader,
    afmHeader,
    addressHeader,
    cityHeader,
    countyHeader,
    postalCodeHeader,
    createdAtHeader,
    outDateHeader,
    organizationHeader,
    userHeader,
    emailCodeHeader
} from "../../components/TableHeaders.js";


const OwnersList = () => {
    const classes = useListStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [owners, setOwners] = useState([]);
    const [inspectors, setInspectors] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [users, setUsers] = useState([]);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [isUpdateOpen, setIsUpdateOpen] = useState(false);
    const [ownerToUpdate, setOwnerToUpdate] = useState(null);

    const fetchData = async () => {
        setIsLoading(true)
        const { owners } = await getOwners();
        setOwners(owners);

        const { inspectors } = await getInspectors();
        setInspectors(inspectors);

        const { organizations } = await getOrganizations();
        setOrganizations(organizations);

        const { users } = await getUsersData();
        setUsers(users)
        setIsLoading(false)
    }

    useEffect(() => {
        fetchData();
    }, []);

    const handleCodeClick = (value) => {
        setIsUpdateOpen(true);
        const owner = owners.find((owner) => owner.code === value)
        const ownerToUpdate = { ...owner };
        const ownersInspector = inspectors.find((inspector) => inspector._id === ownerToUpdate.inspector);
        ownersInspector ? ownerToUpdate.inspector = `${ownersInspector.lastName} ${ownersInspector.firstName}` : ownerToUpdate.inspector = null;

        if (ownerToUpdate?.organization) {
            const ownersOrganization = organizations.find((organization) => organization._id === owner.organization);
            ownersOrganization ? ownerToUpdate.organization = ownersOrganization.name : ownerToUpdate.organization = null;
        }

        if (ownerToUpdate.user) {
            const ownersUser = users.find((user) => user._id === ownerToUpdate.user);
            ownersUser ? ownerToUpdate.user = ownersUser.username : ownerToUpdate.user = null;
        }
        setOwnerToUpdate(ownerToUpdate);
    }

    const tableColumns = useMemo(() => [
        codeHeader(handleCodeClick),
        inspectorHeader(inspectors),
        ownerLastNameHeader,
        firstNameHeader,
        fatherNameHeader,
        afmHeader,
        addressHeader,
        cityHeader,
        countyHeader,
        postalCodeHeader,
        emailCodeHeader,
        createdAtHeader,
        outDateHeader,
        organizationHeader(organizations),
        userHeader(users)
    ])

    return (
        <>
            <Spinner open={isLoading} />
            <Modal open={isCreateOpen} onClose={() => setIsCreateOpen(false)} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Slide direction="left" in={isCreateOpen} mountOnEnter unmountOnExit>
                    <Box className={classes.modalContent}>
                        <Typography variant="h5" className={classes.modal_title}>
                            Προσθήκη Εκτροφής
                        </Typography>
                        <OwnerForm
                            datePickerWidth="100%"
                            isCreate={true}
                            isFromList={true}
                            setIsCreateOpen={setIsCreateOpen}
                            fetchListData={fetchData} />
                    </Box>
                </Slide>
            </Modal>
            <Modal open={isUpdateOpen} onClose={() => setIsUpdateOpen(false)} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Slide direction="left" in={isUpdateOpen} mountOnEnter unmountOnExit>
                    <Box className={classes.modalContent}>
                        <Typography variant="h5" className={classes.modal_title}>
                            Επεξεργασία Εκτροφής
                        </Typography>
                        <OwnerForm
                            datePickerWidth="100%"
                            isCreate={false}
                            isFromList={true}
                            setIsCreateOpen={setIsUpdateOpen}
                            fetchListData={fetchData}
                            fetchedOwner={ownerToUpdate}
                            setFetchedOwner={setOwnerToUpdate}
                            ownerId={ownerToUpdate?._id} />
                    </Box>
                </Slide>
            </Modal>
            <Grid2 container className={classes.container} direction="column" sx={{ marginTop: "1rem", marginLeft: "3rem" }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: "90%", marginBottom: "1rem" }}>
                    <Typography variant="h5" className={classes.form_title}>
                        Εκτροφές
                    </Typography>
                    <Box>
                        <Button variant="contained" sx={{ marginRight: "0.5rem", backgroundColor: "secondary.main" }} onClick={() => window.location.assign('/print/owners')}>
                            PDF
                        </Button>
                        <Button variant="contained" sx={{ backgroundColor: "primary.main" }} onClick={() => setIsCreateOpen(true)}>
                            <AddIcon sx={{ mr: "0.5rem" }} />Προσθήκη εκτροφής
                        </Button>
                    </Box>
                </Box>
                <Table
                    data={owners}
                    noDataText={isLoading ? "Φόρτωση..." : "Δεν υπάρχουν εγγραφές!"}
                    columns={tableColumns}
                    defaultSorted={[{ id: "createdAt", desc: true }]}
                />
            </Grid2>
        </>
    );
}

export default memo(OwnersList);